// src/models/UserProfile.js
class UserProfile {
    constructor({
      displayName,
      email,
      userName,
      bio = '',
      facebookUrl = '',
      instagramUrl = '',
      twitterUrl = '',
      profileImage = '',
      heroImage = '',
      advancedUI = false,
      planId = '',
      subscriptionData = {},
      facilitatorAccessToken = '',
      orderID = '',
      paymentSource = '',
      subscriptionID = '',
      subscriptionDate = null,
      subscriptionStatus = '',
    }) {
      this.displayName = displayName;
      this.email = email;
      this.userName = userName;
      this.bio = bio;
      this.facebookUrl = facebookUrl;
      this.instagramUrl = instagramUrl;
      this.twitterUrl = twitterUrl;
      this.profileImage = profileImage;
      this.heroImage = heroImage;
      this.advancedUI = advancedUI;
      this.planId = planId;
      this.subscriptionData = subscriptionData;
      this.facilitatorAccessToken = facilitatorAccessToken;
      this.orderID = orderID;
      this.paymentSource = paymentSource;
      this.subscriptionID = subscriptionID;
      this.subscriptionDate = subscriptionDate;
      this.subscriptionStatus = subscriptionStatus;
      this.createdAt = new Date();
    }
  
    toPlainObject() {
      return {
        displayName: this.displayName,
        email: this.email,
        userName: this.userName,
        bio: this.bio,
        facebookUrl: this.facebookUrl,
        instagramUrl: this.instagramUrl,
        twitterUrl: this.twitterUrl,
        profileImage: this.profileImage,
        heroImage: this.heroImage,
        advancedUI: this.advancedUI,
        planId: this.planId,
        subscriptionData: this.subscriptionData,
        facilitatorAccessToken: this.facilitatorAccessToken,
        orderID: this.orderID,
        paymentSource: this.paymentSource,
        subscriptionID: this.subscriptionID,
        subscriptionDate: this.subscriptionDate,
        subscriptionStatus: this.subscriptionStatus,
        createdAt: this.createdAt,
      };
    }
  }
  
  export default UserProfile;
  